var _style, _line, _line2, _line3, _line4, _line5, _line6, _line7, _line8, _line9, _line10, _line11, _line12, _line13, _line14, _line15, _line16, _line17, _line18, _line19, _line20, _line21, _line22, _line23, _line24, _line25, _text, _text2, _text3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRouteViewTimeline6(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 144 25",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, "\n    .time { font: 13px sans-serif; fill:rgb(90,90,90)}\n    .line { stroke:rgb(90,90,90); stroke-width:1}\n  ")), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 0,
    y1: 25,
    x2: 300,
    y2: 25,
    className: "line"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 6,
    y1: 20,
    x2: 6,
    y2: 25,
    className: "line"
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 12,
    y1: 20,
    x2: 12,
    y2: 25,
    className: "line"
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    x1: 18,
    y1: 20,
    x2: 18,
    y2: 25,
    className: "line"
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    x1: 24,
    y1: 15,
    x2: 24,
    y2: 25,
    className: "line"
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    x1: 30,
    y1: 20,
    x2: 30,
    y2: 25,
    className: "line"
  })), _line7 || (_line7 = /*#__PURE__*/React.createElement("line", {
    x1: 36,
    y1: 20,
    x2: 36,
    y2: 25,
    className: "line"
  })), _line8 || (_line8 = /*#__PURE__*/React.createElement("line", {
    x1: 42,
    y1: 20,
    x2: 42,
    y2: 25,
    className: "line"
  })), _line9 || (_line9 = /*#__PURE__*/React.createElement("line", {
    x1: 48,
    y1: 20,
    x2: 48,
    y2: 25,
    className: "line"
  })), _line10 || (_line10 = /*#__PURE__*/React.createElement("line", {
    x1: 54,
    y1: 20,
    x2: 54,
    y2: 25,
    className: "line"
  })), _line11 || (_line11 = /*#__PURE__*/React.createElement("line", {
    x1: 60,
    y1: 20,
    x2: 60,
    y2: 25,
    className: "line"
  })), _line12 || (_line12 = /*#__PURE__*/React.createElement("line", {
    x1: 66,
    y1: 20,
    x2: 66,
    y2: 25,
    className: "line"
  })), _line13 || (_line13 = /*#__PURE__*/React.createElement("line", {
    x1: 72,
    y1: 15,
    x2: 72,
    y2: 25,
    className: "line"
  })), _line14 || (_line14 = /*#__PURE__*/React.createElement("line", {
    x1: 78,
    y1: 20,
    x2: 78,
    y2: 25,
    className: "line"
  })), _line15 || (_line15 = /*#__PURE__*/React.createElement("line", {
    x1: 84,
    y1: 20,
    x2: 84,
    y2: 25,
    className: "line"
  })), _line16 || (_line16 = /*#__PURE__*/React.createElement("line", {
    x1: 90,
    y1: 20,
    x2: 90,
    y2: 25,
    className: "line"
  })), _line17 || (_line17 = /*#__PURE__*/React.createElement("line", {
    x1: 96,
    y1: 20,
    x2: 96,
    y2: 25,
    className: "line"
  })), _line18 || (_line18 = /*#__PURE__*/React.createElement("line", {
    x1: 102,
    y1: 20,
    x2: 102,
    y2: 25,
    className: "line"
  })), _line19 || (_line19 = /*#__PURE__*/React.createElement("line", {
    x1: 108,
    y1: 20,
    x2: 108,
    y2: 25,
    className: "line"
  })), _line20 || (_line20 = /*#__PURE__*/React.createElement("line", {
    x1: 114,
    y1: 20,
    x2: 114,
    y2: 25,
    className: "line"
  })), _line21 || (_line21 = /*#__PURE__*/React.createElement("line", {
    x1: 120,
    y1: 15,
    x2: 120,
    y2: 25,
    className: "line"
  })), _line22 || (_line22 = /*#__PURE__*/React.createElement("line", {
    x1: 126,
    y1: 20,
    x2: 126,
    y2: 25,
    className: "line"
  })), _line23 || (_line23 = /*#__PURE__*/React.createElement("line", {
    x1: 132,
    y1: 20,
    x2: 132,
    y2: 25,
    className: "line"
  })), _line24 || (_line24 = /*#__PURE__*/React.createElement("line", {
    x1: 138,
    y1: 20,
    x2: 138,
    y2: 25,
    className: "line"
  })), _line25 || (_line25 = /*#__PURE__*/React.createElement("line", {
    x1: 144,
    y1: 20,
    x2: 144,
    y2: 25,
    className: "line"
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 7,
    y: 12,
    className: "time"
  }, "04:00")), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    x: 55,
    y: 12,
    className: "time"
  }, "12:00")), _text3 || (_text3 = /*#__PURE__*/React.createElement("text", {
    x: 103,
    y: 12,
    className: "time"
  }, "20:00")));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRouteViewTimeline6);
export default __webpack_public_path__ + "static/media/RouteViewTimeline6.d61fa189.svg";
export { ForwardRef as ReactComponent };